import { toast } from 'react-toastify';
import errorHandle from '../../../utils/errorHandle';
import { approveTrip, rejectTrip } from '../../../api/supportAdmin';

export const handleApproveTrip = async (type, packId, setLoading) => {
    setLoading(true);
    try {
        const res = await approveTrip(type, packId);
        if (res.status === 200) {
            setLoading(false);
            toast.success('Trip Approved');
            return res.status;
        }
    } catch (error) {
        setLoading(false);
        errorHandle(error);
    }
};

export const handleRejectTrip = async (type, packId, data, setLoading) => {
    setLoading(true);
    try {
        const commentData = {
            comment: data
        };
        const res = await rejectTrip(type, packId, commentData);
        if (res.status === 200) {
            setLoading(false);
            toast.success('Trip Rejected');
            return res.status;
        }
    } catch (error) {
        setLoading(false);
        errorHandle(error);
    }
};
